import { render, staticRenderFns } from "./ChangeOfName.vue?vue&type=template&id=5b018e06&scoped=true"
import script from "./ChangeOfName.vue?vue&type=script&lang=js"
export * from "./ChangeOfName.vue?vue&type=script&lang=js"
import style0 from "./ChangeOfName.vue?vue&type=style&index=0&id=5b018e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b018e06",
  null
  
)

export default component.exports